import { apiService } from './apiClient';
import { getBackendApiUrl } from './appConfig';

const buildUrl = (path) => `${getBackendApiUrl()}${path}`;

export const usersService = {
  // List all users
  list: () => apiService.get(buildUrl('/api/users')),

  // Get a single user by ID
  get: (id) => apiService.get(buildUrl(`/api/users/${id}`)),

  // Create a new user
  create: (userData) =>
    apiService.post(buildUrl('/api/users/create'), userData),

  // Update a user
  update: (id, userData) =>
    apiService.put(buildUrl(`/api/users/${id}`), userData),

  // Delete a user
  delete: (id) => apiService.delete(buildUrl(`/api/users/${id}`)),

  // Assign a role to a user
  assignRole: (userId, roleId) =>
    apiService.post(buildUrl(`/api/users/${userId}/assign-role`), { role_id: roleId }),

  // Remove a role from a user
  removeRole: (userId, roleId) =>
    apiService.delete(buildUrl(`/api/users/${userId}/remove-role/${roleId}`)),

  // Verify current user profile from token
  // Extracts email from OIDC token and verifies against database with roles
  verifyProfile: () =>
    apiService.get(buildUrl('/api/users/verify-profile')),
};

export default usersService;
